/* ═══════════════════════════════════════════════════
   LANDING HERO — transición de scroll del header
   Vanilla JS, sin librerías.

   DECISIÓN Mau 2026-06-17:
   - El logo del hero YA NO migra al header (sin FLIP, sin animación).
     El logo vive estático dentro del hero y se va con el scroll.
     El JS NUNCA toca sus estilos inline ni lo reparenta.
   - El header normal (.nav__logo) aparece en cuanto el TEXTO del hero
     (el <h1> .landing-hero-full__heading) pasa por debajo del header
     pegajoso. Antes el umbral era 55% / hero completo fuera de viewport.
   - Estado: clase `.landing-scrolled` en <body> (lo visual lo hace el CSS).
   ═══════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* Guard global: si el theme editor re-ejecuta este script al
     re-renderizar la sección, reutiliza la instancia existente
     en lugar de duplicar listeners. Inofensivo en producción. */
  if (window.__landingHero) {
    window.__landingHero.reinit();
    return;
  }

  var cleanup = null; // teardown de la instancia viva (null = sin instancia)

  function init() {
    if (cleanup) return; // idempotente: ya hay una instancia activa

    var hero = document.querySelector('[data-landing-hero]');
    if (!hero) return;

    var nav = document.querySelector('.nav');
    var body = document.body;

    // Elemento de disparo: el TEXTO/heading del hero. Si no existe
    // (hero sin texto), caemos al borde inferior del hero como respaldo.
    var trigger = hero.querySelector('.landing-hero-full__heading') || hero;

    /* ── Estado: DOS disparos independientes ──
       nav-logo-on      → el logo del nav aparece cuando pasa el TEXTO (heading).
       landing-scrolled → la barra blanca aparece cuando pasa TODO el hero. */
    function setState(logoOn, barOn) {
      body.classList.toggle('nav-logo-on', logoOn);
      body.classList.toggle('landing-scrolled', barOn);
    }

    /* ── Detección de scroll (rAF-throttled, no crudo) ──
       Umbral por elemento: el header se asienta (fondo blanco + logo del
       nav visible) en cuanto el borde INFERIOR del heading del hero cruza
       por debajo del header pegajoso. Al volver a subir, se quita. */
    function navHeight() {
      return nav ? nav.getBoundingClientRect().height : 72;
    }

    // Debug opcional: añade ?herodebug a la URL para ver el estado en vivo.
    var dbg = null;
    if (/[?&]herodebug/.test(location.search)) {
      dbg = document.createElement('div');
      dbg.style.cssText = 'position:fixed;top:8px;right:8px;z-index:9999;background:#000;color:#0f0;font:12px/1.4 monospace;padding:6px 9px;border-radius:4px;pointer-events:none;white-space:pre';
      document.body.appendChild(dbg);
    }

    var curLogo = null;   // estado previo del logo (heading)
    var curBar = null;    // estado previo de la barra (hero completo)
    var ticking = false;

    /* Respaldo cross-origin (theme editor): IntersectionObserver sobre el
       heading. Cuando el scroll ocurre en un contenedor PADRE cross-origin
       (canvas del editor), ni llegan eventos de scroll ni cambia
       getBoundingClientRect. IO calcula contra el viewport real. Marca ON
       cuando el heading deja de intersectar el viewport por arriba. */
    var triggerVisible = true;  // heading visible (logo)
    var heroVisible = true;     // hero completo visible (barra)
    var io = null, ioHero = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        triggerVisible = entries[0].isIntersecting;
        evaluate();
      }, { threshold: 0 });
      io.observe(trigger);
      ioHero = new IntersectionObserver(function (entries) {
        heroVisible = entries[0].isIntersecting;
        evaluate();
      }, { threshold: 0 });
      ioHero.observe(hero);
    }

    function evaluate() {
      var nh = navHeight();
      // Logo: ON cuando el borde inferior del HEADING pasa bajo el header.
      var headingBottom = trigger.getBoundingClientRect().bottom;
      var logoOn = headingBottom <= nh || !triggerVisible;
      // Barra blanca: ON solo cuando pasa TODO el hero.
      var heroBottom = hero.getBoundingClientRect().bottom;
      var barOn = heroBottom <= nh || !heroVisible;
      if (dbg) dbg.textContent = 'headingBottom=' + Math.round(headingBottom) + '\nheroBottom=' + Math.round(heroBottom) + '\nnavH=' + Math.round(nh) + '\nlogo=' + logoOn + ' bar=' + barOn;
      if (logoOn !== curLogo || barOn !== curBar) {
        curLogo = logoOn; curBar = barOn;
        setState(logoOn, barOn);
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { evaluate(); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    // Captura: los eventos scroll NO burbujean, pero sí descienden en fase de
    // captura — así oímos cualquier scroller interno (p.ej. el canvas del
    // theme editor, que envuelve la página en su propio contenedor).
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    onScroll(); // estado inicial

    // Theme editor: si el canvas scrollea en un contenedor que no emite
    // eventos alcanzables, un poll con rAF garantiza paridad editor/preview.
    // Gated por designMode — en producción NO corre.
    var pollId = null;
    if (window.Shopify && window.Shopify.designMode) {
      (function poll() {
        evaluate();
        pollId = requestAnimationFrame(poll);
      })();
    }

    /* ── Resize: re-evaluar el umbral (cambia navHeight / layout) ── */
    var rT;
    function onResize() {
      clearTimeout(rT);
      rT = setTimeout(evaluate, 120);
    }
    window.addEventListener('resize', onResize, { passive: true });

    /* ── Teardown: desuscribe todo ── */
    cleanup = function () {
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('scroll', onScroll, { capture: true });
      window.removeEventListener('resize', onResize);
      if (pollId) { cancelAnimationFrame(pollId); pollId = null; }
      if (io) { io.disconnect(); io = null; }
      if (ioHero) { ioHero.disconnect(); ioHero = null; }
      clearTimeout(rT);
      body.classList.remove('landing-scrolled');
      body.classList.remove('nav-logo-on');
      if (dbg && dbg.parentNode) dbg.parentNode.removeChild(dbg);
      cleanup = null;
    };
  }

  function reinit() {
    if (cleanup) cleanup();
    init();
  }

  init();

  /* ── Theme editor (customizer): re-init en re-render de la sección ──
     Los eventos shopify:section:* solo se disparan dentro del editor;
     el gate por designMode hace esto explícitamente inerte en producción.
     e.target es el wrapper de la sección afectada: filtramos por la
     presencia del hero para ignorar re-renders de otras secciones. */
  function isHeroSection(e) {
    return !!(e.target && e.target.querySelector &&
              e.target.querySelector('[data-landing-hero]'));
  }
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:unload', function (e) {
      if (isHeroSection(e) && cleanup) cleanup();
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (isHeroSection(e)) reinit();
    });
  }

  /* API mínima para el guard de re-ejecución (ver arriba) */
  window.__landingHero = { reinit: reinit };
})();
